export const SET_TOKEN = 'SET_TOKEN'
export const CLEAR_TOKEN = 'CLEAR_TOKEN'
export const SET_REFRESH_TOKEN = 'SET_REFRESH_TOKEN'


// WEBPACK FOOTER //
// ./src/store/user/mutations.js